import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loaderType?: "spinner" | "progress"; // Option for different loaders
  progress?: number; // For progress-based loading
  className?: string;
}

export default function Button({
  loading = false,
  loaderType = "spinner",
  progress = 0,
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={loading ? " flex justify-center min-w-20 active:opacity-70 " + className + " active:opacity-70 ": " active:opacity-70 " + className}
    >
      {loading ? (
        loaderType === "progress" ? (
          <div
            className="absolute bottom-0 left-0 h-1 bg-white"
            style={{ width: `${progress}%` }}
          ></div>
        ) : (
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        )
      ) : (
        children
      )}
    </button>
  );
}
